import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-archive-list',
  templateUrl: './archive-list.component.html',
  styleUrls: ['./archive-list.component.scss']
})
export class ArchiveListComponent implements OnInit {
  @Input() posts: any[];

  constructor() { }

  ngOnInit(): void {
  }

}
